import axios from "axios";
import { Fragment, useState,useEffect } from "react";
import React from "react";
import { Dialog, Menu, Transition, Disclosure } from "@headlessui/react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import mainLogo from "../mglogo.png";
import {
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  MenuAlt2Icon,
  ShoppingBagIcon,
  UsersIcon,
  XIcon,
  ExclamationIcon,
  ArchiveIcon,
  ClipboardIcon,
  ShoppingCartIcon,
  TemplateIcon,
  QuestionMarkCircleIcon,
  DocumentIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
  SearchIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  LinkIcon,
  ColorSwatchIcon,
  CogIcon,
} from "@heroicons/react/solid";
import Leadmodalcreate from "./Leadmodalcreate";
import Leadmodaledit from "./Leadmodaledit";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class LeadList extends React.Component {
  constructor(props) {
    super(props);
    this.kabbanView = this.kabbanView.bind(this);
    this.state = {
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      redirect: false,
      kanbanredirect: false,
      deleteRedirect: false,
      logoutRedirect: false,
      cryptKey: "",
      deletealartmsg: false,
      links: [],
      LeadsList: [],
      leadModalopenforcreate: false,
      leadModalopenforedit: false,
      LeadNoteId: "",
      lead_id: "",
      leadNoteList: [],
      LeadNamefornoteView: "",
      leadNotemodalOpen: false,
      perpage: "",
      from: "",
      to: "",
      totalnoofLead: "",
      loader: "",
      overLay: "",
      editId: "",
    };
  }

  setLoaderFunction = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "fixed inset-0 bg-black/30",
    });
  };
  closeLoaderFuncion = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "",
    });
  };
  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };
  open = async (e) => {
    console.log("open")
    this.setState({ sidebarOpen: true });
  };

  delete = async (e) => {
    this.setState({ deletealartmsg: true });
    this.setState({ cryptKey: e });
  };

  handleLeadNote = async (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  haldleDelete = async (e) => {
    if (this.state.deletealartmsg) {
      const token = localStorage.getItem("token");
      let id = this.state.cryptKey;
      //const id=this.setState({cryptKey:e});
      const resDelete = axios
        .get("public/api/lead/delete/" + id, {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((resDelete) => {
          if (resDelete.data.success) {
            this.setState({ deleteRedirect: true });
            this.setState({ deletealartmsg: false });
          }
        });
    }
  };
  componentDidUpdate(prevProps, prevState, snapshot){
   
    if(this.state.deleteRedirect==true){
      this.setState({deleteRedirect:false});
      const token = localStorage.getItem("token");
      const res = axios
      .get("public/api/lead/pagination", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        // console.log(res.data.customers.data);
        const Leads = res.data.leads.data;
        let link = res.data.leads.links;
        this.setState({ LeadsList: Leads });
        this.setState({ loader: "" });
        this.setState({ links: link });
        this.setState({ perpage: res.data.leads.per_page });
        this.setState({ from: res.data.leads.from });
        this.setState({ to: res.data.leads.to });
        this.setState({ totalnoofLead: res.data.leads.total });
        this.closeLoaderFuncion();
      });
  }}
  Search = (e) => {
    this.setLoaderFunction();
    this.state.PurchaseOrder = [];
    const token = localStorage.getItem("token");
    const search = e.target.value;
    const res = axios
      .get("public/api/lead/pagination?search_v=" + search, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        const Leads = res.data.leads.data;
        let link = res.data.leads.links;
        this.setState({ LeadsList: Leads });
        this.setState({ loader: "" });
        this.setState({ links: link });
        this.setState({ perpage: res.data.leads.per_page });
        this.setState({ from: res.data.leads.from });
        this.setState({ to: res.data.leads.to });
        this.setState({ totalnoofLead: res.data.leads.total });
        this.closeLoaderFuncion();
      });
  };
  componentDidMount() {
    this.setLoaderFunction();
    const token = localStorage.getItem("token");
    const res = axios
      .get("public/api/lead/pagination", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        // console.log(res.data.customers.data);
        const Leads = res.data.leads.data;
        let link = res.data.leads.links;
        this.setState({ LeadsList: Leads });
        this.setState({ loader: "" });
        this.setState({ links: link });
        this.setState({ perpage: res.data.leads.per_page });
        this.setState({ from: res.data.leads.from });
        this.setState({ to: res.data.leads.to });
        this.setState({ totalnoofLead: res.data.leads.total });
        this.closeLoaderFuncion();
      });
  }

  LeadNoteviewmodal = (id, e) => {
    const token = localStorage.getItem("token");
    this.state.LeadNoteId = id;
    this.state.lead_id = id;
    // this.setState({LeadNoteId:e});
    //const id=this.setState({cryptKey:e});
    const resView = axios
      .get("public/api/lead/edit/" + e, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((resView) => {
        if (resView.data.success) {
          this.setState({ leadNoteList: resView.data.lead.notes });
          this.setState({ LeadNamefornoteView: resView.data.lead.name });
          this.setState({ leadNotemodalOpen: true });

          // this.setState({LeadNoteId:''});
        } else {
        }
      });
  };

  addLeadnote = async (e) => {
    e.preventDefault();
    this.state.leadNoteList = [];
    var token = localStorage.getItem("token");
    const headers = {
      authorization: `Bearer ${token}`,
      Accept: "application/json",
    };

    const res = await axios.post("public/api/lead/note/store", this.state, {
      headers,
    });

    if (res.data.success) {
      this.setState({ leadNoteList: res.data.lead_notes });

      this.state.note = "";
    } else {
      this.setState({ error_list: res.data.data });
    }
  };

  fun = (e) => {
    this.setState({ leadNotemodalOpen: false });
    this.state.leadNoteList = [];
    this.state.LeadNamefornoteView = "";
  };

  addLeads = (e) => {
    // this.setState({ redirect: true });
    this.setState({ leadModalopenforcreate: true });
  };
  closeLead = () => {
    this.setState({ leadModalopenforcreate: false });
  };

  edit = (e) => {
    this.setState({ leadModalopenforedit: true });
    this.setState({ editId: e });
  };
  closeLeadedit = () => {
    this.setState({ leadModalopenforedit: false });
  };

  handleInputModalleadCreate = (e) => {
    if (e) {
      this.state.LeadsList = [];
      const token = localStorage.getItem("token");
      const res = axios
        .get("public/api/lead/pagination", {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res) => {
          this.setState({ showmsg: true });
          // console.log(res.data.customers.data);
          const Leads = res.data.leads.data;
          let link = res.data.leads.links;
          this.setState({ LeadsList: Leads });
          this.setState({ loader: "" });
          this.setState({ links: link });
          this.setState({ perpage: res.data.leads.per_page });
          this.setState({ from: res.data.leads.from });
          this.setState({ to: res.data.leads.to });
          this.setState({ totalnoofLead: res.data.leads.total });
          this.closeLoaderFuncion();
          this.setState({ leadModalopenforcreate: false });
        });
      setTimeout(
        function () {
          //Start the timer
          this.setState({ showmsg: false });
        }.bind(this),
        1000
      );
    }
  };
  handleInputModalleadEdit = (e) => {
    console.log(e);
    if (e) {
      this.setState({ showmsg: true });
      this.state.LeadsList = [];
      const token = localStorage.getItem("token");
      const res = axios
        .get("public/api/lead/pagination", {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res) => {
          // console.log(res.data.customers.data);
          const Leads = res.data.leads.data;
          let link = res.data.leads.links;
          this.setState({ LeadsList: Leads });
          this.setState({ loader: "" });
          this.setState({ links: link });
          this.setState({ perpage: res.data.leads.per_page });
          this.setState({ from: res.data.leads.from });
          this.setState({ to: res.data.leads.to });
          this.setState({ totalnoofLead: res.data.leads.total });
          this.closeLoaderFuncion();
          this.setState({ leadModalopenforedit: false });
        });
      setTimeout(
        function () {
          //Start the timer
          this.setState({ showmsg: false });
        }.bind(this),
        2000
      );
    }
  };

  kabbanView = (e) => {
    this.setState({ kanbanredirect: true });
    //this.props.navigate('/filterby/Lead');
  };

  paginationFetch = async (e) => {
    if (e) {
      this.setLoaderFunction();
      this.setState({ loader: "animate-pulse" });
      const token = localStorage.getItem("token");
      const res = axios
        .get(e, {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res) => {
          // console.log(res.data.customers.data);
          const Leads = res.data.leads.data;
          let link = res.data.leads.links;
          this.setState({ LeadsList: Leads });
          this.setState({ links: link });
          this.setState({ loader: "" });
          this.setState({ perpage: res.data.leads.per_page });
          this.setState({ from: res.data.leads.from });
          this.setState({ to: res.data.leads.to });
          this.setState({ totalnoofLead: res.data.leads.total });
          this.closeLoaderFuncion();
        });
    }
  };

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("public/api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    //console.log(res);

    if (res.data.success) {
      localStorage.removeItem("token");

      //Start the timer
      this.setState({ logoutRedirect: true }); //After 1 second, set render to true
    }
  };

  render() {
    let token = localStorage.getItem("token");

    
    if (token == null) {
      return <Navigate to={"/Login"} />;
    }
    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    
      if (this.state.kanbanredirect) {
        this.state.kanbanredirect=false;
          this.setState({kanbanredirect:this.state.kanbanredirect});
        return <Navigate to={"/filterby/Lead"} />;
      }
   
    
   

    return (
      <>
        <div>
          <div className={this.state.overLay} aria-hidden="true" />
      

          {/* Static sidebar for desktop */}
          
          
                  {/* Replace with your content */}
                  <div className="px-4 sm:px-6 lg:px-8">
                    <div className="sm:flex sm:items-center">
                      <div className="sm:flex-auto">
                        <h1 className="text-xl font-semibold text-gray-900">
                          Leads
                        </h1>
                        <p className="mt-2 text-sm text-gray-700">
                          A list of Leads
                        </p>
                      </div>
                      <span className="hidden sm:block ml-3">
                        <button
                          onClick={this.kabbanView}
                          type="button"
                          className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        >
                          <LinkIcon
                            className="-ml-1 mr-2 h-5 w-5 text-gray-500"
                            aria-hidden="true"
                          />
                          View in Kanban
                        </button>
                      </span>
                      <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                        <button
                          onClick={this.addLeads}
                          type="button"
                          className="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                        >
                          New Lead
                        </button>
                      </div>
                    </div>
                    <div className="mt-8 flex flex-col">
                      <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                          <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                            <table
                              className={`min-w-full divide-y divide-gray-300 ${this.state.loader}`}
                            >
                              <thead className="bg-gray-50">
                                <tr>
                                  <th
                                    scope="col"
                                    className="py-3 pl-4 pr-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500 sm:pl-6"
                                  >
                                    Lead Name
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                  >
                                    Phone
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                  >
                                    Lead Value
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                  >
                                    Source
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                  >
                                    Status
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3 text-center text-xs font-medium uppercase tracking-wide text-gray-500"
                                  >
                                    Action
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="divide-y divide-gray-200 bg-white">
                                {this.state.LeadsList.map((person) => (
                                  <tr key={person.id}>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                      {person.name}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                      {person.phone}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                      {person.lead_value}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                      {person.lead_state.name}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                      {person.lead_source.name}
                                    </td>
                                    <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                      <span
                                        onClick={() =>
                                          this.LeadNoteviewmodal(
                                            person.id,
                                            person.id_crypt
                                          )
                                        }
                                        className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-300 text-green-800 cursor-pointer"
                                      >
                                        View Note
                                      </span>

                                      <span
                                        onClick={() =>
                                          this.edit(person.id_crypt)
                                        }
                                        className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 cursor-pointer"
                                      >
                                        Edit
                                      </span>
                                      <span
                                        onClick={() =>
                                          this.delete(person.id_crypt)
                                        }
                                        className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-pink-100 text-pink-800 cursor-pointer"
                                      >
                                        Delete
                                      </span>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/*pagination*/}

                  <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
                    <div className="flex-1 flex justify-between sm:hidden"></div>
                    <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                      <div>
                        <p className="text-sm text-gray-700">
                          Showing{" "}
                          <span className="font-medium">{this.state.from}</span>{" "}
                          to{" "}
                          <span className="font-medium">{this.state.to}</span>{" "}
                          of{" "}
                          <span className="font-medium">
                            {this.state.totalnoofLead}
                          </span>{" "}
                          results
                        </p>
                      </div>
                      <div>
                        <nav
                          className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
                          aria-label="Pagination"
                        >
                          {/* Current: "z-10 bg-indigo-50 border-indigo-500 text-indigo-600", Default: "bg-white border-gray-300 text-gray-500 hover:bg-gray-50" */}

                          {this.state.links.map((person) => (
                            <a
                              onClick={() => this.paginationFetch(person.url)}
                              aria-current="page"
                              className="z-10 bg-indigo-50 border-indigo-500 text-indigo-600 relative inline-flex items-center px-4 py-2 border text-sm font-medium cursor-pointer"
                            >
                              <p>{person.label}</p>
                            </a>
                          ))}
                        </nav>
                      </div>
                    </div>
                  </div>

                  {/*pagination/}

   {/* /End replace */}
                
        </div>
        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <CheckCircleIcon
                        className="h-6 w-6 text-green-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        Successfully Saved
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
        {/*DeleteAlert */}
        <Transition.Root show={this.state.deletealartmsg} as={Fragment}>
          <Dialog
            as="div"
            className="fixed z-10 inset-0 overflow-y-auto"
            onClose={() => this.setState({ deletealartmsg: false })}
          >
            <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
              </Transition.Child>

              {/* This element is to trick the browser into centering the modal contents. */}
              <span
                className="hidden sm:inline-block sm:align-middle sm:h-screen"
                aria-hidden="true"
              >
                &#8203;
              </span>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <div className="relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                  <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                    <button
                      type="button"
                      className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      onClick={() => this.setState({ deletealartmsg: false })}
                    >
                      <span className="sr-only">Close</span>
                      <XIcon className="h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>
                  <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                      <ExclamationIcon
                        className="h-6 w-6 text-red-600"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                      <Dialog.Title
                        as="h3"
                        className="text-lg leading-6 font-medium text-gray-900"
                      >
                        Delete Lead
                      </Dialog.Title>
                      <div className="mt-2">
                        <p className="text-sm text-gray-500">
                          Are you sure you want to delete the Lead ?
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                    <button
                      type="button"
                      className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                      onClick={this.haldleDelete}
                    >
                      Delete
                    </button>
                    <button
                      type="button"
                      className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
                      onClick={() => this.setState({ deletealartmsg: false })}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition.Root>
        {/*End DeleteAlert */}

        {/*Lead Note view */}
        <Transition.Root show={this.state.leadNotemodalOpen} as={Fragment}>
          <Dialog as="div" className="relative z-10" onClose={this.fun}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8  md:max-w-screen-md lg:max-w-screen-lg sm:w-full sm:p-6">
                    <div>                  
                      <div className="mt-3  sm:mt-5">
                        <Dialog.Title
                          as="h3"
                          className="text-lg leading-6 font-medium text-gray-900"
                        ></Dialog.Title>
                        <div className="mt-2">
                          <div className="bg-white shadow overflow-hidden sm:rounded-lg">
                            <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
                              <section aria-labelledby="notes-title">
                                <div className="bg-white shadow sm:rounded-lg sm:overflow-hidden">
                                  <div className="divide-y divide-gray-200">
                                    <div className="px-4 py-5 sm:px-6">
                                      <h2
                                        id="notes-title"
                                        className="text-lg font-medium text-gray-900"
                                      >
                                        Lead Notes-{" "}
                                        {this.state.LeadNamefornoteView}
                                      </h2>
                                    </div>
                                    <div className="px-4 py-6 sm:px-6">
                                      <ul role="list" className="space-y-8">
                                        {this.state.leadNoteList.map(
                                          (comment) => (
                                            <li key={comment.id}>
                                              <div className="flex space-x-3">
                                                <div className="flex-shrink-0">
                                                  <span className="inline-block h-6 w-6 rounded-full overflow-hidden bg-gray-100">
                                                    <svg
                                                      className="h-full w-full text-gray-300"
                                                      fill="currentColor"
                                                      viewBox="0 0 24 24"
                                                    >
                                                      <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                                                    </svg>
                                                  </span>
                                                </div>
                                                <div>
                                                  <div className="text-sm">
                                                    <a
                                                      href="#"
                                                      className="font-medium text-gray-900"
                                                    ></a>
                                                  </div>
                                                  <div className="mt-1 text-sm text-gray-700">
                                                    <p>{comment.note}</p>
                                                  </div>
                                                  <div className="mt-2 text-xs	 space-x-2">
                                                    <span className="text-gray-400 font-small">
                                                      {comment.created_at}
                                                    </span>{" "}
                                                  </div>
                                                </div>
                                              </div>
                                            </li>
                                          )
                                        )}
                                      </ul>
                                    </div>
                                  </div>
                                  <div className="bg-gray-50 px-4 py-6 sm:px-6">
                                    <div className="flex space-x-3">
                                      <div className="flex-shrink-0">
                                        <span className="inline-block h-6 w-6 rounded-full overflow-hidden bg-gray-100">
                                          <svg
                                            className="h-full w-full text-gray-300"
                                            fill="currentColor"
                                            viewBox="0 0 24 24"
                                          >
                                            <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                                          </svg>
                                        </span>
                                      </div>
                                      <div className="min-w-0 flex-1">
                                        <form
                                          action="#"
                                          onSubmit={this.addLeadnote}
                                        >
                                          <div>
                                            <label
                                              htmlFor="note"
                                              className="sr-only"
                                            >
                                              Note
                                            </label>
                                            <textarea
                                              id="note"
                                              name="note"
                                              rows={2}
                                              value={this.state.note}
                                              onChange={this.handleLeadNote}
                                              className="shadow-sm block w-full focus:ring-blue-500 focus:border-blue-500 sm:text-sm border border-gray-300 rounded-md"
                                              placeholder="Add a note"
                                              defaultValue={""}
                                            />
                                          </div>
                                          <div className="mt-3 flex items-center justify-between">
                                            <button
                                              type="submit"
                                              className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                            >
                                              Add
                                            </button>
                                          </div>
                                        </form>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </section>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                      <button
                        type="button"
                        className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                        onClick={this.fun}
                      >
                        Cancel
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
        {/*Lead Note view */}
        {/*Modal Create */}
        <Transition.Root show={this.state.leadModalopenforcreate} as={Fragment}>
          <Dialog as="div" className="relative z-10" onClose={this.closeLead}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end lg:items-center  justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8  md:max-w-screen-md lg:max-w-screen-lg sm:w-full sm:p-6">
                    <div>                  
                      <Leadmodalcreate
                        handleInputlead={this.handleInputModalleadCreate}
                      />
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
        {/* Modal Create*/}
        {/*Modal Edit */}
        <Transition.Root show={this.state.leadModalopenforedit} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-10"
            onClose={this.closeLeadedit}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end lg:items-center  justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8  md:max-w-screen-md lg:max-w-screen-lg sm:w-full sm:p-6">
                    <div>                  
                      <Leadmodaledit
                        leadId={this.state.editId}
                        handleInputlead={this.handleInputModalleadEdit}
                      />
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
        {/* Modal Edit*/}
      </>
    );
  }
}

export default LeadList;
